import { render } from "./ArchiveNotice.vue?vue&type=template&id=583f9ef4&scoped=true"
import script from "./ArchiveNotice.vue?vue&type=script&lang=js"
export * from "./ArchiveNotice.vue?vue&type=script&lang=js"

import "./ArchiveNotice.vue?vue&type=style&index=0&id=583f9ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583f9ef4"]])

export default __exports__